import {
  Box,
  Typography,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
} from "@mui/material";
import { Controller, FieldError, useFormContext } from "react-hook-form";
import { useTranslation } from "../../../../../hooks/useTranslation";
import { GeneralSettingsFormValues } from "../GeneralSettings";
import { Info } from "@mui/icons-material";

export const TaxLiabilitySettings = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<GeneralSettingsFormValues>();

  const { translate, translateWithoutPrefix } = useTranslation(
    "pages.stores.settings.generalSettings",
  );

  const getErrorMessage = (error: FieldError | undefined) => {
    if (error?.type === "required") {
      return translateWithoutPrefix("common.errors.required");
    } else if (error?.type === "min") {
      return translateWithoutPrefix("common.errors.min", { min: 1 });
    }

    return "";
  };

  return (
    <Box display="flex" alignItems="center" mb={2}>
      <Typography variant="body2" fontWeight="bold" sx={{ width: "20%" }}>
        {translate("taxLiability")}:
      </Typography>
      <Controller
        control={control}
        name="taxingSetting"
        render={({ field }) => (
          <Box alignItems={"center"} gap={"20px"}>
            <RadioGroup {...field} value={field.value ?? ""}>
              <FormControlLabel
                value="CLOSED"
                control={<Radio />}
                label={translate("closed")}
              />
              <FormControlLabel
                value="ACTIVE"
                control={<Radio />}
                label={translate("active")}
              />
            </RadioGroup>
            {field.value === "ACTIVE" && (
              <>
                <Box display="flex" alignItems="center" gap="10px">
                  <Typography variant="body2">
                    {translate("taxLiabilityPercentage")}:
                  </Typography>
                  <TextField
                    {...register("taxPercentage", { required: true, min: 0 })}
                    type="number"
                    variant="outlined"
                    size="small"
                    slotProps={{
                      input: {
                        endAdornment: (
                          <Typography sx={{ paddingLeft: "8px" }}>%</Typography>
                        ),
                      },
                    }}
                    error={!!errors.taxPercentage}
                    sx={{ width: "100px" }}
                  />
                  <Tooltip title={translate("taxLiabilityTooltip")}>
                    <Info color="primary" fontSize="small" />
                  </Tooltip>
                </Box>
                {errors.taxPercentage && (
                  <Typography color="error" variant="caption">
                    {getErrorMessage(errors.taxPercentage)}
                  </Typography>
                )}
              </>
            )}
          </Box>
        )}
      />
    </Box>
  );
};
